import { useContext, useState } from "react";
import FileUploader from "../../../../../../util/component/FileUploader";
import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import {useTranslation} from "react-i18next";
import { blobToBase64String } from "blob-util";
import { useParams } from "react-router-dom"; 
import { getDocumentsRs, insertDocumentRs } from "../../../../search-repair-shop/rsSearch.actions";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { useSetRecoilState } from "recoil";
import { documentsRsState } from "../../../../search-repair-shop/state";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { IUploadFileWrapper } from "./types";

const UploadFileWrapper = ({open, setOpen}: IUploadFileWrapper) => {
    const {id} = useParams();
    const {t} = useTranslation(["network", "translation"]);
    const setDocumentRs = useSetRecoilState(documentsRsState);
    const {dispatchGlobalData} = useContext(GlobalContext);

    const [fileDetails, setFileDetails] = useState<object>({});

    const handleUpload = (newFile: File) => {
        blobToBase64String(newFile).then((res) => {
            setFileDetails({
                id,
                fileName: newFile.name,
                documentFile: res,
                type: newFile.type
            });
        }).catch(() => {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t('error.tryLater'),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        })
    }

    const removeFileHandler = () => {
        setFileDetails({})
    }

    const handleExit = () => {
        removeFileHandler()
        setOpen(false);
    }

    const handleSave = () => {
        insertDocumentRs(fileDetails)
            .then(() => {
                getDocumentsRs({id})
                    .then((res: any) => {
                        setDocumentRs(res?.document);
                    })
                    .catch(() => {
                        dispatchGlobalData({
                            type: setSnackbar,
                            payload: {
                                snackbar: {
                                    message: t('error.tryLater'),
                                    type: snackbarTypes.error,
                                    show: true,
                                    autoClose: true,
                                }
                            }
                        });
                    });
            })
            .catch(() => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('error.tryLater'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            }).finally(() => {
                handleExit();
            });
    }

    return (
        <Dialog
            open={open}
            onClose={handleExit}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("rsDetail.documentRepositoryDms.dialog.title")}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <FileUploader onUpload={handleUpload} onRemove={removeFileHandler} isDirectUpload />
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleExit} variant="outlined">
                    {t("rsDetail.documentRepositoryDms.dialog.action.cancel")}
                </Button>
                <Button onClick={handleSave} autoFocus disabled={Object.keys(fileDetails).length === 0}>
                    {t("rsDetail.documentRepositoryDms.dialog.action.save")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default UploadFileWrapper;
